import { Close } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import FormControlAutocomplete from "src/components/shared/FormControlAutocomplete";
import FormControlInput from "src/components/shared/FormControlInput";
import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import useCustomerBrandDetail from "src/hooks/user/customer/useCustomerBrandDetail";

const ProductForm = ({ index, onRemoveProduct, inventoryOptions = [], inventoryData = [], onProductSearchChange, inventoryLoading = false }) => {
  const form = useFormContext();
  const { products, customer } = form.watch();
  const { data: customerBrand } = useCustomerBrandDetail(customer?.value);
  const product = form.watch(`products.${index}.product`);

  const productModelOptions = useMemo(() => {
    return inventoryData
      ?.find((v) => v?._id === product?.value)
      ?.productModels?.map((v) => ({
        label: v?.name,
        value: v?._id,
        price: v?.price,
        qty: v?.qty,
        lockQty: v?.lockQty,
      }));
  }, [product?.value, inventoryData]);

  const handleRemoveProduct = () => {
    onRemoveProduct(index);
  };

  useEffect(() => {
    const data = Array.isArray(customerBrand) ? customerBrand?.find((v) => v?.brand?._id === product?.brand) : {};
    if (data) {
      form.setValue(`products.${index}.discount`, data?.discount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product?.brand, customerBrand, index]);

  return (
    <Stack
      gap="12px"
      mt="12px"
    >
      {products.length > 1 && (
        <IconButton
          sx={{
            background: "var(--light-grey)",
            width: "24px",
            height: "24px",
            alignSelf: "flex-end",
          }}
          onClick={handleRemoveProduct}
        >
          <Close sx={{ fontSize: "18px" }} />
        </IconButton>
      )}
      <FormControlAutocomplete
        name={`products.${index}.product`}
        label="Sản phẩm"
        options={inventoryOptions}
        placeholder="Sản phẩm"
        required
        loading={inventoryLoading}
        filterOptions={(opts) => opts}
        onInputChange={(_, value, reason) => {
          if (reason === "input") onProductSearchChange?.(value);
          if (reason === "clear") onProductSearchChange?.("");
        }}
        onChange={(value) => {
          if (value) onProductSearchChange?.("");
          form.setValue(`products.${index}.productModel`, null);
        }}
      />
      <FormControlAutocomplete
        key={product}
        name={`products.${index}.productModel`}
        label="Phân loại"
        options={productModelOptions}
        placeholder="Phân loại"
        getOptionLabel={(option) => option?.label + ` (Tồn kho khả dụng: ${option?.qty - option?.lockQty ?? 0})`}
        required
      />
      <FormControlInput
        name={`products.${index}.qty`}
        label="Số lượng"
        placeholder="Số lượng"
        type="number"
        required
      />
      <FormControlInput
        name={`products.${index}.discount`}
        label="Chiết khấu (%)"
        placeholder="Chiết khấu"
        type="number"
        required
      />
    </Stack>
  );
};

export default ProductForm;
